import { HttpHeaders } from '@angular/common/http';

export var contentHeaders = new HttpHeaders();

contentHeaders.append('Accept', 'application/json');
contentHeaders.append('Content-Type', 'application/json');

let apiUrls = [ "http://192.168.0.9:4000/api/",
				"https://newapi.test.livechek.com/api/",
				"https://newapi.livechek.com/api/" ];

let misapiUrl =  "https://newmis.livechek.com/api/"

export const apiBaseUrl = apiUrls[2];

export const apiMisUrl = misapiUrl;
